import type { YMap, YMapCollection, YMapFeatureProps } from '@yandex/ymaps3-types'
import type { Sector } from '@/new-services/types/sectors'

import { getSectors } from '@/new-services/sectors.service'

import { reactive } from 'vue'

import mapObjects from '@/modules/YandexMap3Module/map-objects'

type InitializeModuleOptions = {
    mapInstance: YMap
    dispatcherSectorId: number
}

export default function() {
    let mapInstance: YMap | null = null
    let sectorsCollection: YMapCollection | null = null

    const state = reactive({
        is_loading: false,
        is_failed: false,
        list: [] as Sector[],
    })

    const convertSectorToFeatureProps = (sector: Sector): YMapFeatureProps => {
        return {
            id: `sector-${sector.id}`,
            geometry: {
                type: 'Polygon',
                coordinates: [JSON.parse(sector.coordinates).map((coordinates: number[]) => coordinates.reverse())],
            },
            style: {
                stroke: [{ width: 1, opacity: 0.2, color: sector.color }],
                fill: sector.color,
                fillOpacity: 0.2,
                zIndex: 1,
            },
            properties: {
                hint: {
                    text: `Сектор ${sector.name}`
                }
            }
        }
    }

    const loadSectors = async (dispatcherSectorId: number) => {
        if (!mapInstance) return
        
        const { YMapCollection } = ymaps3

        sectorsCollection = new YMapCollection({})
        mapInstance.addChild(sectorsCollection)

        try {
            state.is_loading = true

            const response = await getSectors({
                page: 1,
                limit: 9999,
                dispatcherSectorIds: [dispatcherSectorId]
            })

            state.list = response.data.data

            response.data.data.forEach((sector) => {
                (sectorsCollection as YMapCollection).addChild(
                    mapObjects.createFeature(convertSectorToFeatureProps(sector))
                )
            })

            state.is_failed = false
        } catch (error) {
            console.error(error)
            state.is_failed = true
        } finally {
            state.is_loading = false
        }
    }

    const initializeModule = (options: InitializeModuleOptions): Promise<void> => {
        mapInstance = options.mapInstance
        return loadSectors(options.dispatcherSectorId)
    }

    const destroyModule = () => {
        if (!mapInstance || !sectorsCollection) return

        mapInstance.removeChild(sectorsCollection as YMapCollection)
        sectorsCollection = null

        state.is_loading = false
        state.is_failed = false
        state.list = []
    }

    return {
        state,
        initializeModule,
        destroyModule,
    }
}